<template>
  <div
    id="inbox-navigator"
    class="flex-align-center">
    <!-- <icon /> -->
    <div
      class="greedy">
      <BusinessDropdown
        ref="businessDropdown"
        :merchant="merchant"
        location="Inbox"
        :auto-width="true"
        :auto-height="true"
        :no-hover="true"/>
    </div>
    <span class="icon new-conversation"/>
    <UserDropdown
      class="px-0"
      :availability-toggle-shown="true"
      :size="UserDropdownButtonSize.S"/>
    <span class="icon edit"/>
  </div>
</template>

<style lang="scss" scoped>
#inbox-navigator {
  display: flex;
  padding: 13px 15px;
}
</style>

<script>
import { mapGetters } from 'vuex';
import BusinessDropdown from './BusinessDropdown';
import UserDropdown from '../common/UserDropdown';
import UserDropdownButtonSize from '../../helpers/lists/userDropdownButtonSize';

export default {
  name: 'InboxNavigator',
  components: {
    BusinessDropdown,
    UserDropdown,
  },
  data() {
    return {
      UserDropdownButtonSize,
    };
  },
  computed: {
    ...mapGetters({
      merchant: 'merchant/merchant',
    }),
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
